import React from "react";

import EmptyStateCard from "../../../components/EmptyStateCard";

const FinanceIcon = () => (
  <svg viewBox="0 0 24 24">
    <rect x="2.5" y="6" width="19" height="13" rx="3" />
    <path d="M2.5 10.5h19" />
    <circle cx="17" cy="14.8" r="1.1" />
  </svg>
);

const FinanceEmptyState = ({ state, onRetry, retryLabel = "Try Again", inline = false, children }) => {
  if (!state) return null;

  return (
    <EmptyStateCard
      inline={inline}
      icon={<FinanceIcon />}
      title={state.title}
      body={state.body}
      actions={
        onRetry && (
          <button type="button" className="sy-flow-btn sy-flow-btn-ghost" onClick={onRetry}>
            {retryLabel}
          </button>
        )
      }
    >
      {children}
    </EmptyStateCard>
  );
};

export default FinanceEmptyState;
